module.exports = __webpack_public_path__ + "static/media/bab.0b546225.svg";